import {ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit, ViewEncapsulation} from '@angular/core';
import {FormArray, FormGroup} from "@angular/forms";
import {HarbourDuesCargoHandlingCountForm} from "../../types";
import {HarbourDuesService} from "../../services/harbour-dues.service";

@Component({
  selector: 'app-equipment-list-amsterdam',
  templateUrl: './equipment-list-amsterdam.component.html',
  styleUrls: ['./equipment-list-amsterdam.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class EquipmentListAmsterdamComponent implements OnInit, OnDestroy {

  @Input() list: FormArray<FormGroup<HarbourDuesCargoHandlingCountForm>>;
  @Input() type: string;


  constructor(private service: HarbourDuesService) { }

  ngOnInit(): void {
    this.list.enable();
    this.addDefaultEquipment();
  }

  ngOnDestroy() {
    this.list.disable();
  }

  addDefaultEquipment() {
    if (this.list.length < 1) {
      this.addEquipment();
    }
  }

  addEquipment() {
    this.list.push(this.service.newCargoCount());
  }

  formatEmpty(b: boolean) {
    return b ? 'Empty' : 'Full';
  }

  deleteEquipmentItem(i: number) {
    this.list.removeAt(i);
  }
}
